import { useIntl } from 'react-intl'
import ErrorPage from './ErrorPage'

/**
 * Not found page
 * @constructor
 */
const NotFound = () => {
	const { formatMessage } = useIntl()

	return (
		<ErrorPage
			code={formatMessage({ id: 'global.errorPages.unauthorized.code' })}
			explanation={formatMessage({ id: 'global.errorPages.unauthorized.explanation' })}
			message={formatMessage({ id: 'global.errorPages.unauthorized.message' })}
		/>
	)
}

export default NotFound
